"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";
import { PortableText } from "@portabletext/react";
import { richTextComponent } from "@/sanity/sanityPortableText";
import { PageChallengeSchema } from "@/sanity/pages/PageChallengeTemplate";
import ChipSerif from "@/components/global/ui/ChipSerif";
import checkbox from "@/public/challenge/checkbox.svg";
import { motion } from "framer-motion";
import FAQList from "@/components/global/ui/FAQList";
import { PortableTextBlock } from "sanity";
import { PageAffiliateSchema } from "@/sanity/pages/PageAffiliateTemplate";
import iqicon from "@/public/affiliate/iqIcon.svg";
import { CTAButton } from "@/shadcn/ui/button";
import { PageTextOnlyLPSchema } from "@/sanity/pages/PageTextOnlyLPTemplate";

export default function ThisPageSection({
  data,
  className,
}: {
  data: PageTextOnlyLPSchema;
  className?: string;
}) {
  return (
    <section
      className={cn(
        "relative overflow-clip py-[3rem] lg:py-[9rem] px-[4rem] lg:px-[6rem] w-full",
        className,
      )}
    >
      <div className="w-full flex flex-col items-start relative bg-white">
        {data.thisPageTitle && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="richtext richtext-start prose-h2:text-[3.5rem] lg:prose-h2:text-[4rem] mb-[4rem] [&_br]:hidden lg:[&_br]:block"
          >
            <PortableText
              value={data.thisPageTitle}
              components={richTextComponent}
            />
          </motion.div>
        )}
        {data.thisPageContent && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.3, ease: [0.25, 0.46, 0.45, 0.94] }}
            className="richtext richtext-start prose-p:text-[2rem] lg:prose-p:text-[2rem] text-[#103037]/80
            prose-strong:text-[2.15rem] prose-strong:font-medium
            [&_.greenBlock]:w-full [&_.greenBlock]:mb-[3rem]
            [&_.squareTopicListNoDivisor]:w-full "
          >
            <PortableText
              value={data.thisPageContent}
              components={richTextComponent}
            />
          </motion.div>
        )}
      </div>
    </section>
  );
}
